<template>
    <a-modal
            title="商户资料修改"
            :width="640"
            :visible="visible"
            :confirmLoading="confirmLoading"
            @ok="handleSubmit"
            @cancel="handleCancel"
    >
        <a-spin :spinning="confirmLoading">
            <a-form :form="form">
                <a-form-item
                        label="商户名称"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-input v-decorator="['vendorName', {initialValue: formData.vendorName, rules: [{required: true, min: 2, message: '请输入至少两个字符！'}]}]" />
                </a-form-item>
                <a-form-item
                        label="商户地址"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-input v-decorator="['address', {initialValue: formData.address, rules: [{required: true, min: 2, message: '请输入至少两个字符！'}]}]" />
                </a-form-item>
                <a-form-item
                        label="联系方式"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-input v-decorator="['phone', {initialValue: formData.phone, rules: [{required: true, min: 2, message: '联系方式格式有误',
                    validator: (rule, value, cbfn) => {
                        var reg= /^((0\d{2,3}-\d{7,8})|(1\d{10}))$/;
                        if(!reg.test(value))
                            cbfn('联系方式格式有误')
                         cbfn()
                      }}]}]" />
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script>
    export default {
        data () {
            return {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 7 }
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 13 }
                },
                visible: false,
                confirmLoading: false,

                form: this.$form.createForm(this),
                formData: {},
            }
        },
        props: {
            formType: ''
        },
        methods: {
            showForm(formData) {
                this.form.resetFields()
                this.visible = true
                this.formData = formData
            },

            handleSubmit () {
                const { form: { validateFields } } = this
                this.confirmLoading = true
                validateFields((errors, values) => {
                    if (!errors) {
                        values.id = this.formData.id
                        setTimeout(() => {
                            this.visible = false
                            this.confirmLoading = false
                            this.$emit('submit', values)
                        }, 1500)
                    } else {
                        this.confirmLoading = false
                    }
                })
            },
            handleCancel () {
                this.visible = false
            }
        },
    }
</script>
